import React, { useState, useEffect } from 'react';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WorldWebOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
//import { Box, Typography, Grid2, textFieldClasses, } from '@mui/material';
import { isDesktop } from 'react-device-detect';
import { Helmet } from 'react-helmet-async';
import formatPhone from "../utils/formatPhoneNumber";
import useScrollToTop from '../components/useScrollToTop';
import dayjs from 'dayjs'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from "react-router-dom";


function SpecificResourcePage(props) {
    //const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    const [times, setTimes] = useState(
        {
            "Sunday": ["Closed"],
            "Monday": ["Closed"],
            "Tuesday":["Closed"],
            "Wednesday":["Closed"],
            "Thursday":["Closed"],
            "Friday":["Closed"],
            "Saturday":["Closed"]
        });
    const marginLen = isDesktop ? "75%" : "88%"


    useScrollToTop();

    useEffect(() => {
        if (props !== undefined) {
            console.warn(props.resource);
            setTimes(getStringTimes(props.resource.openTimes));
        }
    }, [props]);



    const getStringTimes = (times) => {
        let copyTimes = {};
        try {
            for (const key in times) {
                if (times[key].length === 0) {
                    copyTimes[key] = Array(1).fill("Closed");
                }
                else {
                    copyTimes[key] = times[key].map((time, i) => {
                        if (i % 2 === 0) {
                            return (`${dayjs(times[key][i]).format("h:mm A")} - ${dayjs(times[key][i + 1]).format("h:mm A")}`);
                        } else {
                            return "";
                        }
                    })
                }
                if(copyTimes[key].length > 1) {
                    copyTimes[key].splice(1, 1);
                }
            }
        }
        catch (err) {
            console.log(err);
        }
        return copyTimes;
    }


    return (
        <>
            <Helmet>
                <title>{props.resource.name} - Tippy County Connect</title>
                <meta name="description" content={`Find details about ${props.resource.name}, including services, location, and availability.`} />
                <meta name="keywords" content="homeless services, community aid, shelters, food assistance, LTHC resources" />
            </Helmet>
            
            <div className='flex flex-col min-[1430px]:fixed mx-10 my-2' style={{ width: marginLen }}>
                    <Link to={"/resourcestab/resources"} 
                    className="bg-button_yellow text-black py-2 px-3 rounded-lg font-semibold hover:bg-hover_button_yellow w-fit items-center shadow-md">
                        <div className="flex flex-row items-center min-[1430px]:gap-1 text-[17px] md:text-[22px]  w-fit">                        
                            <span className='max-[1430px]:hidden mb-[1px]'><ArrowForwardIcon className='rotate-180' /></span>
                            <span className='min-[1430px]:hidden mb-[1px]'><ArrowForwardIcon className='rotate-180' fontSize='small'/></span> 
                            <p className='font align-text-middle mt-[1px]'>Back</p> 
                        </div>
                    </Link>
                </div>
            <div className="flex flex-col items-center gap-100" >
                {/**Back button */}
                
                {/*Header*/}
                <div className="flex" style={{
                    display: "flex",
                    background: "#016C9D",
                    width: "100%",
                    height: "200px",
                    //padding: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "30px"
                }}
                >
                    <div className="font-bold text-[45px] sm:text-[64px] text-white justify-center"
                        style={{ justifyContent: 'center', textAlign: "center", }}>
                        {props.resource.name}
                    </div>
                </div>
                <div className="mb-5" style={{ display: "flex", width: marginLen, height: "150%", }}>
                </div>


                <div className='flex flex-col' style={{ width: marginLen }}>

                    <div className="font-bold text-[28px] sm:text-[36px]"
                        style={{ justifyContent: 'left', }}>
                        Resource Overview
                    </div>
                    <div className="mb-5" style={{
                        display: "flex",
                        width: "100%",
                        height: "100%",
                    }}>
                    </div>
                    <ul className="list-disc list-inside text-[22px] sm:text-[28px] mb-5">
                        {props.resource.overview===""?"":<li className="my-3"><span className='font-bold'>About: </span> {props.resource.overview}</li>}
                        {props.resource.services===""?"":<li className="my-3"><span className='font-bold'>Services Offered: </span>{props.resource.services}</li>}
                        {props.resource.access===""?"": <li className="my-3"><span className='font-bold'>Access: </span>{props.resource.access}</li>}
                        {props.resource.eligibility===""?"":<li className="my-3"><span className='font-bold'>Eligibility: </span>{props.resource.eligibility}</li>}
                    </ul>
                </div>

                {/*Line break with margins */}
                <div className='flex my-5' style={{ width: marginLen, height: "2px", background: "#000", }}>
                </div>


                <div className='flex flex-row ' style={{ width: marginLen }}>

                    <div className='flex flex-col max-w-[520px] min-w-[48%] w-full sm:mr-[8px]'>

                        <div className="font-bold text-[28px] sm:text-[36px] max-w-[520px] mb-5"
                            style={{ justifyContent: 'left', }}>
                            Hours of Operation
                        </div>

                        {/**Days and times */}
                        <div className='flex flex-col max-w-[520px] w-full'>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Sunday:
                                </p>
                                {times !== undefined && times !== null ? times["Sunday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Monday:
                                </p>
                                {times !== undefined && times !== null ? times["Monday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Tuesday:
                                </p>
                                {times !== undefined && times !== null ? times["Tuesday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Wednesday:
                                </p>
                                {times !== undefined && times !== null ? times["Wednesday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Thursday:
                                </p>
                                {times !== undefined && times !== null ? times["Thursday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Friday:
                                </p>
                                {times !== undefined && times !== null ? times["Friday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>
                            <div className='flex flex-row justify-between ' style={{ width: "100%" }}>
                                <p className="font text-[22px] sm:text-[28px] w-fit">
                                    Saturday:
                                </p>
                                {times !== undefined && times !== null ? times["Saturday"].map((time) =>
                                    <p className="font text-[25px] sm:text-[28px] w-fit">
                                        {time}
                                    </p>) : null
                                }
                            </div>

                        </div>
                    </div>


                    {/**Vertical Line */}
                    <div className='flex max-[1440px]:hidden w-full'>
                        <div className='relative max-[1440px]:hidden mx-7 justify-center' style={{ width: "2px", background: "#000", }}>
                        </div>
                        <div className='flex max-[1440px]:hidden w-fit' style={{}}>
                            <ContactInfo resource={props.resource} />
                        </div>
                    </div>
                </div>


                {/*Line break with margins */}
                <div className='flex my-5' style={{ width: marginLen, height: "2px", background: "#000", }}>
                </div>

                {/**Contact info */}
                <div className='hidden max-[1440px]:flex' style={{ width: marginLen }}>
                    <ContactInfo resource={props.resource} />

                </div>

                {/*Line break with margins */}
                <div className='hidden max-[1440px]:flex my-5' style={{ width: marginLen, height: "2px", background: "#000", }}>
                </div>

                <div className='flex flex-col' style={{ width: marginLen }}>
                    <div className="font-bold text-[28px] sm:text-[36px]"
                        style={{ justifyContent: 'left', }}>
                        Location Map
                    </div>
                    <div className="mb-5" style={{
                        display: "flex",
                        width: "100%", height: "100%",
                    }}>

                    </div>
                    <iframe
                        style={{ position: "inline", padding: "2vh" }}
                        title="map"
                        width="96%"
                        height={isDesktop ? "550" : "300"}
                        frameBorder="0"
                        referrerPolicy="no-referrer-when-downgrade"
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAZg61q1ejUnk97tQt6ZJcfkxoTmJ794As&q=${encodeURIComponent(props.resource.address)}`}
                        allowFullScreen>
                    </iframe>

                </div>

                <div className="mb-5" style={{ display: "flex", width: marginLen, height: "20px%", }}>
                </div>


            </div>
        </>

    )
}
function ContactInfo(props) {
    return (

        <div className='flex flex-col ' >
            <div className="font-bold text-[28px] sm:text-[36px] mb-5"
                style={{ justifyContent: 'left', }}>
                Contact Information
            </div>


            <div className="font text-[22px] sm:text-[28px]"
            >
                {props.resource.phone === "" ? "" : <PhoneOutlinedIcon style={{ fontSize: "50px" }} className="text-black" />}
                {" "}
                {props.resource.phone === "" ? "" :
                    <a href={`tel:${props.resource.phone}`} >{formatPhone(props.resource.phone)}</a>
                }
            </div>
            <div className="font text-[22px] sm:text-[28px]"
                style={{ justifyContent: 'left', }}>
                {props.resource.email === "" ? "" : <EmailOutlinedIcon style={{ fontSize: "50px" }} className="text-black" />}
                {" "}
                <a href={`mailto:${props.resource.email}`} >{props.resource.email}</a>
            </div>
            <div className="text-blue text-[22px] sm:text-[28px] "
                style={{ justifyContent: 'left' }}>
                {props.resource.website === "" ? "" : <WorldWebOutlinedIcon style={{ fontSize: "50px" }} className="text-black" />}
                {" "}
                {props.resource.website === "" ? "" : <u>
                    <a href={props.resource.website} target="_blank" rel="noreferrer" style={{ color: "blue" }}>
                        {props.resource.name + " Website"}
                    </a></u>}

                {/*<Typography fontSize="28px" position="inline" paddingBottom="3vh" paddingLeft="1vh" paddingRight="2.5vh" component="a" href={`https://www.${props.resource.website}`}>
                        {props.resource.website}</Typography>*/}
            </div>

            <div className="font text-[22px] sm:text-[28px]"
                style={{ justifyContent: 'left', }}>
                {props.resource.address === "" ? "" : <LocationOnOutlinedIcon style={{ fontSize: "50px" }} className="text-black" />}
                {" "}
                {props.resource.address === "" ? "" : <u>
                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(props.resource.address)}&travelmode=transit`} target="_blank" rel="noreferrer" style={{ color: "blue" }}>
                        {props.resource.address}
                    </a></u>}
            </div>

        </div>
    )
}
export default SpecificResourcePage;
